import { Outlet } from "react-router";
import HomePageFooter from "../layout/homePage/footer/HomePageFooter";
import Hero from "../layout/homePage/hero/hero";
import Navbar from "../layout/homePage/navbar/navbar";
import OurFeatures from "../layout/homePage/ourFeatures/ourFeatures";
import AboutUsHome from "../layout/homePage/aboutUs/aboutUsHome";

export default function HomePage() {
  return (
  <>
    <Navbar />
    <Outlet />
    <Hero />
    <AboutUsHome />
    <OurFeatures />
    <HomePageFooter />
            

  </>
);
}